export type BLTheme = {
  color: {
    white: string;
    gray1: string;
    gray2: string;
    gray3: string;
    gray5: string;
    black: string;
    blueLight: string;
    blueLight2: string;
    blueLighter: string;
    blue: string;
    orange: string;
    red: string;
    green: string;
    greenLight: string;
    blueSapphire: string;
    greenWinter: string;
    silverPale: string;
    pinkMountbatten: string;
    redShimmering: string;
    yellowOrange: string;
  };
  font: {
    workSans: string;
    roboto: string;
  };
  media: {
    mobileHeight: number;
  };
  spacing: (size: number) => number;
};

export const theme: BLTheme = {
  color: {
    white: "#FFFFFF",

    gray1: "#F4F5F7",
    gray2: "#DFE1E6",
    gray3: "#B3BAC5",
    gray5: "#7A869A",
    black: "#2D2D2D",
    blueLight: "#457DD9",
    blueLight2: "#45B6D9",
    blueLighter: "#6C97DE",
    blue: "#030f85",
    orange: "#FFBD67",
    red: "#EF7C83",
    green: "#82BEA2",
    greenLight: "#82BEA226",

    // 2nd palette (EDB status for example and Shipping Record status)
    blueSapphire: "#1C5C70",
    greenWinter: "#5C977F",
    silverPale: "#C5B9B3",
    pinkMountbatten: "#9A7A97",
    redShimmering: "#D88196",
    yellowOrange: "#F6CC69",
  },
  font: {
    workSans: "Work Sans, sans-serif",
    roboto: "Roboto, sans-serif",
  },
  media: {
    mobileHeight: 768,
  },
  spacing: (size: number) => size * 6,
};
